import { Info } from "lucide-react";

/**
 * Mention légale obligatoire sous chaque publication de type "qa" (questions patients).
 * UX réglementaire CDC v1.0 §5 / US-13.
 */
export default function MedicalDisclaimer({ inline = false }) {
  if (inline) {
    return (
      <p className="text-[11px] text-slate-500 italic mt-2 leading-relaxed" data-testid="medical-disclaimer-inline">
        <Info className="inline h-3 w-3 me-1 -translate-y-0.5" aria-hidden="true" />
        Cet échange ne constitue pas un avis médical personnalisé et n'engage pas la responsabilité des professionnels qui y répondent. En cas d'urgence, appelez le 15.
      </p>
    );
  }
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-xs text-amber-900 flex items-start gap-2" data-testid="medical-disclaimer-block" role="note">
      <Info className="h-4 w-4 text-amber-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <span>
        <strong>Mention légale :</strong> les réponses publiées ne constituent pas un avis médical personnalisé.
        En cas d'urgence, appelez le 15 (SAMU). Consultez toujours un professionnel de santé pour un diagnostic personnalisé.
      </span>
    </div>
  );
}
